export const treeDataJson = [
  {
    id: 1,
    text: "测试数据1",
  },
  {
    id: 2,
    text: "测试数据2",
  },
  {
    id: 3,
    text: "测试数据3",
  },
];
// 菜单配置
export const elMenuData2 = [
  {
    title: "高程影像",
    icon: "el-icon-landscape",
    key: "elevationImage",
  },
  {
    title: "模型",
    icon: "el-icon-yonghuguanli-32",
    key: "model",
  },
  {
    title: "环境编辑",
    icon: "las la-cut",
    key: "terrain",
  },
  {
    title: "矢量数据",
    icon: "las la-shapes",
    key: "shp",
  },
  {
    title: "标绘",
    icon: "small-operation-btn el-icon-edit",
    key: "plotItem",
  },
  {
    title: "资源",
    icon: "el-icon-GIS",
    key: "imageResources",
    // submenu: [
    //   {
    //     title: "图片资源",
    //     key: "imageResources",
    //   },
    //   {
    //     title: "视频资源",
    //     key: "videoRresources",
    //   },
    //   {
    //     title: "文件资源",
    //     key: "documentResources",
    //   },
    // ],
  },
  {
    title: "交组模拟",
    icon: "las la-shapes",
    key: "timeline",
  },
  {
    title: "交通模拟",
    icon: "las la-shapes",
    key: "trafficSimulation",
  },
];
